<template>
  <div>
    <router-link v-if="!isDeviceLinked" class="device" to="/link">
      <img class="device__icon" src="@/assets/icon-device.svg" />
      {{ $t("LINK_YOUR_DEVICE") }}
      <span class="device__mobile-text">&nbsp;{{ $t("TO_INSTALL_APPS") }}</span>
    </router-link>
    <button
      v-else
      class="device device_linked"
      :class="{ device_expanded: isDropdownShown }"
      @click="toggleDropdown"
    >
      <img class="device__icon" src="@/assets/icon-device.svg" />
      <span class="device__selected">{{ $t("SELECTED_DEVICE") }}</span>
      <span class="device__text">{{ currentDevice.name }}</span>
      <span class="device__pro" v-if="currentDevice.plus">PLUS</span>
      <img
        class="device__d-icon device__d-icon_desktop"
        src="@/assets/icon-dropdown-white.svg"
      />
      <img
        class="device__d-icon device__d-icon_mobile"
        src="@/assets/icon-dropdown-black.svg"
      />
      <span class="device__desc">
        {{ currentDevice.title }}),
        {{config.signing_with}}
        <template v-if="!hasPlus && config && config.free_signs_left != undefined">
          {{ $t('N_FREE_SIGNS_LEFT', {n: config.free_signs_left}) }}
        </template>
      </span>

      <ul class="dropdown" v-show="isDropdownShown">
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/buy">{{
              $t("HOW_TO_SIDELOAD")
            }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/apple">{{
              $t("INSTALL_CONFIGURE_YOUR_DEV_ACCOUNT_PLUS")
            }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/plus">{{
              $t("BUY_PLUS")
            }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/p2p-certificates">{{
              $t("P2P_SIGNING_MARKETPLACE_MENU_TITLE")
            }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/devices">{{
            $t("MY_DEVICES")
          }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/billing">{{
              $t("MY_SUBSCRIPTIONS_AND_PURCHASES")
            }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/apps"
            >{{ $t("MY_APPS_TITLE") }}</router-link
          >
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/installation-history"
            >{{ $t("MY_INSTALLATION_HISTORY") }}</router-link
          >
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/dylibs"
            >{{ $t("MY_DYLIBS") }}</router-link
          >
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/repos"
            >{{ $t("MY_REPOSITORIES") }}</router-link
          >
        </li>
        <!--<li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/updates">{{
            $t("CHECK FOR UPDATES")
          }}</router-link>
        </li>-->
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/configure">{{
            $t("CONFIGURE_FEATURES")
          }}</router-link>
        </li>
        <!--<li class="dropdown__item dropdown__item_desktop">
          <router-link class="dropdown__link dropdown__link_bold" to="/my"
            >{{ $t('VIEW MORE') }} <img class="dropdown__icon" src="@/assets/icon-more.svg"
          /></router-link>
        </li>-->
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/status">{{
            $t("VIEW DEVICE STATUS")
          }}</router-link>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/change-email">{{
            $t("CHANGE_EMAIL")
          }}</router-link>
        </li>
        <li class="dropdown__item">
          <a class="dropdown__link" href="https://rtfm.dbservices.to/#/troubleshooting/app-installations" target="_blank">
            {{ $t("TROUBLESHOOTING") }}
          </a>
        </li>
        <li class="dropdown__item">
          <router-link class="dropdown__link" to="/my/unlink">{{
              $t("UNLINK THIS DEVICE")
            }}</router-link>
        </li>
      </ul>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isDropdownShown: false,
    };
  },
  computed: {
    ...mapGetters(['hasPlus', 'config']),
    isDeviceLinked() {
      return this.$store.getters.isDeviceLinked;
    },
    currentDevice() {
      const { devices } = this.$store.getters;
      if (devices.length) {
        return devices.find(device => device.lt === this.$store.getters.lt);
      }

      const { config } = this.$store.getters;
      if (Object.keys(config).length) {
        return {
          name: config.name,
          title: `${config.nice_idevice_model} (${config.ios_version}`,
          signing_with: config.signing_with,
        };
      }

      return null;
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownShown = !this.isDropdownShown;
    },
    handleDropdown(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('device'))) {
        return;
      }
      this.isDropdownShown = false;
    },
  },
  mounted() {
    document.body.addEventListener('click', this.handleDropdown);
  },
  destroyed() {
    document.body.removeEventListener('click', this.handleDropdown);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.device {
  display: flex;
  font-size: 14px;
  align-items: center;
  background-color: $primary;
  color: #fff;
  padding: 10px;
  font-weight: 500;
  background: $primary;
  box-shadow: 0 2px 4px 0 var(--shadow-color);
  border-radius: 2px;
  position: relative;
  @include transition;

  &:hover {
    box-shadow: 0 2px 8px 0 var(--shadow-clor);

    @include notebook {
      box-shadow: none;
    }
  }

  @include notebook {
    height: 41px;
    box-shadow: none;
    transition: none;

    &:not(&_linked) {
      background: none;
      color: $primary;
      border: 1px solid $primary;
    }
  }

  &_linked {
    background-image: $header-device-button-gradient;
    border: 1px solid $dark-primary;
    max-width: 170px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 22px;

    @include notebook {
      background: var(--tertiary-bg);
      border: none;
      max-width: 300px;
      color: var(--text-primary);
      padding-top: 17px;
      padding-bottom: 3px;
      width: 100%;
      min-width: 110px;
    }
  }

  &_expanded {
    @include notebook {
      position: absolute;
      z-index: 9;
      height: auto;
      top: 0;
      background: var(--bg);
      border: 1px solid var(--tertiary-accent);
      box-shadow: 0 4px 10px 0 var(--shadow-color);
      border-radius: 8px;
      width: auto;
      flex-direction: column;
      align-items: flex-start;
      padding: 10px 10px 0;
      overflow: hidden;
      max-width: calc(100vw - 85px);
      width: 206px;
    }
  }

  &__mobile-text {
    display: none;

    @include notebook {
      display: inline-block;
    }

    @media (max-width: 420px) {
      display: none;
    }
  }

  &__icon {
    position: relative;
    top: 1px;
    margin-right: 5px;

    @include notebook {
      display: none;
    }
  }

  &_expanded &__pro {
    @include notebook {
      margin-left: 0;
      position: absolute;
      left: 95px;
      top: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 10px;

      & + .device__pro {
        left: 135px;
      }
    }
  }

  &__pro {
    display: none;

    @include notebook {
      display: block;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      background: $primary;
      border-radius: 1.5px;
      padding: 3px 5px;
      color: #fff;
      margin-left: 6px;
    }
  }

  &_expanded &__d-icon {
    @include notebook {
      display: none;
    }
  }

  &__d-icon {
    position: relative;
    right: -12px;

    &_desktop {
      @include notebook {
        display: none;
      }
    }
    &_mobile {
      display: none;

      @include notebook {
        display: block;
        position: absolute;
        right: 7px;
        top: 0;
        bottom: 0;
        margin: auto;
        filter: var(--img-filter);
      }
    }
  }

  &_expanded &__selected {
    @include notebook {
      background: var(--tertiary-accent);
      border-radius: 2px;
      padding: 2px;
      position: static;
      order: 0;
    }
  }

  &__selected {
    display: none;

    @include notebook {
      display: block;
      text-align: left;
      color: var(--text-secondary);
      font-size: 10px;
      font-weight: 400;
      position: absolute;
      top: 5px;
      left: 10px;
    }
  }

  &_expanded &__text {
    @include notebook {
      margin: 4px 0;
      order: 2;
      white-space: normal;
    }
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @include notebook {
      text-align: left;
    }
  }

  &_expanded &__desc {
    @include notebook {
      display: block;
      position: static;
      order: 2;
      white-space: normal;
      text-align: left;
    }
  }

  &__desc {
    position: absolute;
    right: 0;
    color: var(--text-primary);
    font-size: 12px;
    white-space: nowrap;
    bottom: -20px;
    pointer-events: none;

    @include notebook {
      display: none;
    }
  }

  &_expanded .dropdown {
    @include notebook {
      width: calc(100% + 20px);
      margin-top: 10px;
      position: relative;
      left: -10px;
      top: 0;
      right: 0;
      order: 4;

      &__link {
        color: var(--text-primary);
        padding: 5px 10px;
        white-space: normal;
      }

      &__item {
        &:first-child:after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          height: 1px;
          background-color: var(--tertiary-accent);
        }

        &:after,
        &:before {
          left: 0 !important;
          right: 0 !important;
        }
      }
    }
  }
}

.dropdown {
  position: absolute;
  top: 35px;
  right: -1px;
  background: var(--bg);
  border: 1px solid var(--light-primary);
  box-shadow: 0 0 15px 0 var(--shadow-color), 0 4px 10px 0 var(--shadow-color);
  border-radius: 2px;
  z-index: 9;
  text-align: left;

  @include notebook {
    left: 0;
    right: 0;
    border: none;
    box-shadow: none;
  }

  &__item {
    position: relative;

    &_desktop {
      @include notebook {
        display: none;
      }
    }

    &_mobile {
      display: none;

      @include notebook {
        display: block;
      }
    }

    &:not(:last-child):before {
      content: "";
      display: block;
      position: absolute;
      left: 5px;
      right: 5px;
      bottom: 0;
      height: 1px;
      background-color: var(--tertiary-accent);
    }
  }

  &__link {
    display: flex;
    align-items: center;
    color: $primary;
    font-size: 12px;
    padding: 9px 16px;
    white-space: nowrap;
    @include transition;

    &:hover {
      background-color: var(--lighter-primary);
    }

    &_bold {
      justify-content: center;
      color: var(--text-tertiary);
      font-weight: 600;
    }
  }

  &__icon {
    margin-left: 3px;
  }
}
</style>
